const setWith = require('lodash/setWith');

/**
 * Set a path in an object, respecting Falcor-style arrays-as-number-keyed-objects
 * @param {Object} object - the target object
 * @param {string} path - the path to set in the object
 * @param {*} value - the value to set
 * @returns {Object} - the updated object
 */
function set(object, path, value) {
  return setWith(object, path, value, Object);
}

module.exports = set;
